export default function CTASection() {
  return (
    <section className="relative py-28 md:py-36 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/059236d2a3566299e10bc3ef31fc0d30.jpg"
          alt="Flow & Glow Studio Köln"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/60 via-charcoal/50 to-charcoal/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-8 text-center">
        <span className="inline-block font-sans text-xs tracking-widest uppercase text-rose/90 font-semibold mb-4">
          Köln · Kosmetische Zahnaufhellung
        </span>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-medium text-white mb-6 leading-tight">
          Bereit für dein<br />
          <em className="italic" style={{ fontStyle: 'italic' }}>strahlendes Lächeln?</em>
        </h2>
        <p className="font-sans text-base md:text-lg text-white/70 leading-relaxed mb-10 max-w-xl mx-auto">
          Buche jetzt deinen Wunschtermin — schmerzfrei, ohne Peroxid und mit echter Expertise aus 19 Jahren Dentalbranche.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="https://simplybook.me"
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-rose hover:bg-rose-dark text-white font-sans font-medium text-base px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-calendar-line text-base" />
            </span>
            Jetzt Termin buchen
          </a>
          <a
            href="https://wa.me/4922100000"
            rel="nofollow noreferrer"
            className="inline-flex items-center justify-center gap-2 border border-white/40 hover:border-white/80 text-white font-sans font-medium text-base px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-base" />
            </span>
            WhatsApp schreiben
          </a>
        </div>

        {/* Reassurance */}
        <div className="flex flex-wrap justify-center gap-6 mt-10">
          {['Keine Anzahlung', 'Kostenlose Beratung', 'Peroxidfrei'].map((tag) => (
            <div key={tag} className="flex items-center gap-2">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-check-line text-rose text-sm" />
              </span>
              <span className="font-sans text-sm text-white/70">{tag}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
